import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { KalAutocompleteOption } from '@kalidea/kaligraphi';
import { tap } from 'rxjs/operators';
import { BeneficiaryPickerComponent } from 'src/app/_shared/components/beneficiary-picker/beneficiary-picker.component';
import {
    SharedBeneficiaryContactSelectionBase, SharedBeneficiaryContactSelectionInformations
} from 'src/app/_shared/components/shared-beneficiary-contact-selection/shared-beneficiary-contact-selection-base';
import { BenefComboModel } from 'src/graphql/generated-types';
import { BaseComponent } from 'src/app/_core/tools/base.component';

@Component({
    selector: 'app-shared-beneficiary-selection',
    templateUrl: './shared-beneficiary-selection.component.html',
    styleUrls: ['./shared-beneficiary-selection.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedBeneficiarySelectionComponent extends BaseComponent implements OnInit {
    @ViewChild(BeneficiaryPickerComponent) beneficiaryComponent: BeneficiaryPickerComponent;

    @Input() title = null;
    @Input() datasource: SharedBeneficiaryContactSelectionBase = null;
    @Input({transform: coerceBooleanProperty})
    showMatricules = false;

    beneficiaryList: SharedBeneficiaryContactSelectionInformations[] = [];

    filtersFunction: (item: KalAutocompleteOption<SharedBeneficiaryContactSelectionInformations>) => boolean = null;

    selectBeneficiary(beneficiary: KalAutocompleteOption<BenefComboModel>): void {
        this.datasource.addBeneficiaries([beneficiary.value]);
    }

    constructor(protected readonly cdr: ChangeDetectorRef) {
        super(cdr);
    }

    get label(): string {
        const plural = this.datasource?.beneficiaryList?.length > 1 ? 's' : '';
        return this.title ? this.title : `Bénéficiaire${plural} à contacter`;
    }

    deleteAll(): void {
        this.watch$ = this.datasource?.deleteAll();
    }

    ngOnInit(): void {
        this.watch$ = this.datasource.beneficiaryList$.pipe(
            tap(e => {
                this.beneficiaryList = e;
                if (this.beneficiaryComponent) {
                    this.beneficiaryComponent.cdr.markForCheck();
                }
                this.cdr.markForCheck();
            })
        );

        this.filtersFunction = (item: KalAutocompleteOption<BenefComboModel>) => !this.datasource.beneficiaryList.map(({Id}) => Id).includes(item?.value?.Id);
    }

}
